/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const cloud_upload_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#cloud_upload_medium_svg__a)">
      <path
        fill="#000"
        d="m5.066 7.087.14.737-.14-.737Zm13.872 1.925-.742-.11a.75.75 0 0 0 .8.858l-.058-.748ZM8.126 8.32a.75.75 0 1 0 .748-1.3l-.748 1.3Zm-2.635 9.408a.75.75 0 1 0 .131-1.495l-.131 1.495ZM18.5 16.25a.75.75 0 0 0 0 1.5v-1.5ZM11.25 23a.75.75 0 0 0 1.5 0h-1.5Zm3.22-4.97a.75.75 0 1 0 1.06-1.06l-1.06 1.06ZM12 14.5l.53-.53a.75.75 0 0 0-1.06 0l.53.53Zm-3.53 2.47a.75.75 0 1 0 1.06 1.06l-1.06-1.06ZM22.5 13a3.25 3.25 0 0 1-3.25 3.25v1.5A4.75 4.75 0 0 0 24 13h-1.5ZM1.75 12a4.252 4.252 0 0 1 3.456-4.176L4.927 6.35A5.752 5.752 0 0 0 .25 12h1.5Zm4.062-4.828C6.195 3.822 9.184 1.75 12 1.75V.25c-3.456 0-7.195 2.528-7.679 6.752l1.49.17ZM12 1.75c4.143 0 6.7 3.737 6.196 7.153l1.484.218C20.3 4.913 17.17.25 12 .25v1.5Zm6.995 8.01C20.85 9.617 22.5 11.137 22.5 13H24c0-2.741-2.399-4.946-5.12-4.736l.115 1.496ZM5.205 7.824a4.301 4.301 0 0 1 2.921.496l.748-1.3a5.801 5.801 0 0 0-3.947-.67l.279 1.474Zm.417 8.41A4.25 4.25 0 0 1 1.75 12H.25a5.75 5.75 0 0 0 5.24 5.728l.132-1.495ZM18.5 17.75h.75v-1.5h-.75v1.5Zm-2.97-.78-3-3-1.06 1.06 3 3 1.06-1.06Zm-4.06-3-3 3 1.06 1.06 3-3-1.06-1.06ZM12.75 23v-8.5h-1.5V23h1.5Z"
      />
    </g>
    <defs>
      <clipPath id="cloud_upload_medium_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default cloud_upload_medium
